import { AfterContentInit, Directive, ElementRef, Input, OnChanges, inject } from '@angular/core';
import { AgrRendererService } from 'src/app/_shared/directives/agr-renderer.service';

@Directive({
  selector: '[agrAutoFocus]',
  standalone: false
})
export class AgrAutofocusDirective implements AfterContentInit, OnChanges {
  private el = inject(ElementRef);
  private agrRendererService = inject(AgrRendererService);

  @Input() agrAutoFocus: boolean;

  ngOnChanges(): void {
    if (!this.agrAutoFocus) {
      return;
    }
    this.focus();
  }

  ngAfterContentInit(): void {
    this.focus();
  }

  private focus(): void {
    setTimeout(() => {
      this.agrRendererService.invokeElementMethod(this.el, 'focus');
    }, 1);
  }
}
